import { useEffect, useRef } from "react";
import { HONEYBOOK_PID } from "../data/site";

const CONTROLLER_SRC =
  "https://widget.honeybook.com/assets_users_production/websiteplacements/placement-controller.min.js";

export const HoneyBookForm = () => {
  const hostRef = useRef(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    host.replaceChildren();

    const placement = document.createElement("div");
    placement.className = `hb-p-${HONEYBOOK_PID}-1`;
    host.appendChild(placement);

    const pixel = document.createElement("img");
    pixel.height = 1;
    pixel.width = 1;
    pixel.style.display = "none";
    pixel.src = `https://www.honeybook.com/p.png?pid=${HONEYBOOK_PID}`;
    pixel.alt = "";
    host.appendChild(pixel);

    window._HB_ = window._HB_ || {};
    window._HB_.pid = HONEYBOOK_PID;

    const script = document.createElement("script");
    script.src = CONTROLLER_SRC;
    script.async = true;
    host.appendChild(script);

    return () => {
      script.remove();
      host.replaceChildren();
    };
  }, []);

  return (
    <div
      ref={hostRef}
      aria-label="HoneyBook inquiry form"
      data-testid="honeybook-form"
      className="min-h-[400px] w-full"
    />
  );
};
